import script from "./AtomBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomBadge.vue?vue&type=script&lang=ts&setup=true"

import "./AtomBadge.vue?vue&type=style&index=0&id=76d1c796&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d1c796"]])

export default __exports__